import { render, staticRenderFns } from "./MobileMenuItem.vue?vue&type=template&id=62b231d8"
import script from "./MobileMenuItem.vue?vue&type=script&lang=ts"
export * from "./MobileMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports